import { useState } from "react";
import API from "../api/axios";
import toast from "react-hot-toast";
//import { formatDate } from "../utils/cache";

const ADMIN_SECRET = "TopTechAdmin2024!FJ";

export default function AdminDashboard() {
  const [authenticated, setAuthenticated] = useState(false);
  const [password, setPassword] = useState("");
  const [stats, setStats] = useState(null);
  const [businesses, setBusinesses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [updating, setUpdating] = useState(null);
  const [announcement, setAnnouncement] = useState({subject: "", message: "", target: "all"});
const [sending, setSending] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (password !== ADMIN_SECRET) {
      toast.error("Invalid admin password");
      return;
    }
    setLoading(true);
    try {
      const [statsRes, bizRes] = await Promise.all([
        API.get("/admin/stats", { headers: { "x-admin-secret": ADMIN_SECRET } }),
        API.get("/admin/businesses", { headers: { "x-admin-secret": ADMIN_SECRET } }),
      ]);
      setStats(statsRes.data);
      setBusinesses(bizRes.data);
      setAuthenticated(true);
    } catch {
      toast.error("Failed to load admin data");
    } finally {
      setLoading(false);
    }
  };

  const handleUpgrade = async (businessId, plan, status, days) => {
    setUpdating(businessId);
    try {
      await API.post(
        `/admin/businesses/${businessId}/subscription`,
        { plan, status, days },
        { headers: { "x-admin-secret": ADMIN_SECRET } }
      );
      toast.success("Subscription updated");
      const res = await API.get("/admin/businesses", { headers: { "x-admin-secret": ADMIN_SECRET } });
      setBusinesses(res.data);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Update failed");
    } finally {
      setUpdating(null);
    }
  };

  const handleDelete = async (businessId, name) => {
    if (!window.confirm(`Delete ${name} and all their data? This cannot be undone.`)) return;
    try {
      await API.delete(`/admin/businesses/${businessId}`, {
        headers: { "x-admin-secret": ADMIN_SECRET }
      });
      toast.success("Business deleted");
      setBusinesses(businesses.filter(b => b.id !== businessId));
    } catch {
      toast.error("Delete failed");
    }
  };

  const handleAnnouncement = async () => {
  if (!announcement.subject || !announcement.message) {
    toast.error("Subject and message are required");
    return;
  }
  setSending(true);
  try {
    const res = await API.post("/admin/send-announcement", announcement, {
      headers: { "admin-secret": "TopTechAdmin2024!FJ" }
    });
    toast.success(res.data.message);
    setAnnouncement({ subject: "", message: "", target: "all" });
  } catch (err) {
    toast.error(err.response?.data?.detail || "Failed to send");
  } finally {
    setSending(false);
  }
};

  if (!authenticated) {
    return (
      <div style={s.loginWrapper}>
        <div style={s.loginCard}>
          <div style={s.loginLogo}>
            <span style={{ fontSize: "32px" }}>⚡</span>
            <span style={s.loginTitle}>Admin Panel</span>
          </div>
          <p style={s.loginSub}>StackSense — MartSense</p>
          <form onSubmit={handleLogin} style={s.loginForm}>
            <div style={s.field}>
              <label style={s.label}>Admin Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter admin password"
                required
                style={s.input}
              />
            </div>
            <button type="submit" disabled={loading} style={s.loginBtn}>
              {loading ? "Loading..." : "Access Admin Panel"}
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div style={s.wrapper}>
      <div style={s.header}>
        <div style={s.headerLeft}>
          <img
  src="/logo.png"
  alt="MartSense"
  style={{ width: "80px", height: "80px", objectFit: "contain" }}
/>
          <div>
            <h1 style={s.pageTitle}>Admin Dashboard</h1>
            <p style={s.pageSub}>StackSense Technologies — MartSense Sales & inventory Tracker</p>
          </div>
        </div>
        <button onClick={() => setAuthenticated(false)} style={s.logoutBtn}>
          Logout
        </button>
      </div>

      {stats && (
        <div style={s.statsGrid}>
          {[
            { label: "Total Businesses", value: stats.total_businesses, icon: "🏢" },
            { label: "Total Users (incl. team)", value: stats.total_users, icon: "👤" },
            { label: "Total Sales", value: stats.total_sales, icon: "💰" },
            { label: "Total Revenue", value: `₦${stats.total_revenue.toLocaleString()}`, icon: "📈" },
            { label: "Active Subscriptions", value: stats.active_subscriptions, icon: "✅" },
          ].map((stat) => (
            <div key={stat.label} style={s.statCard}>
              <span style={s.statIcon}>{stat.icon}</span>
              <p style={s.statValue}>{stat.value}</p>
              <p style={s.statLabel}>{stat.label}</p>
            </div>
          ))}
        </div>
      )}

      <h2 style={s.sectionTitle}>Registered Businesses</h2>
      <div style={s.tableWrap}>
        <table style={s.table}>
          <thead>
            <tr>
              {["Business", "Email", "Joined", "Plan", "Status", "Products", "Sales", "Actions"].map((h) => (
                <th key={h} style={s.th}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {businesses.map((b) => (
              <tr key={b.id} style={s.tr}>
                <td style={s.td}>{b.name}</td>
                <td style={{ ...s.td, color: "#5a8a8a" }}>{b.email}</td>
                <td style={{ ...s.td, color: "#5a8a8a", whiteSpace: "nowrap" }}>
                  {new Date(b.created_at).toLocaleDateString("en-NG", {
                  timeZone: "Africa/Lagos",
                  day: "numeric", month: "short", year: "numeric"
                  })} 
                </td>
                <td style={s.td}>
                  <span style={{
                    ...s.planBadge,
                    background: b.plan === "pro" ? "#1a2e1a" : b.plan === "basic" ? "#1a1a2e" : "#1e1e1e",
                    color: b.plan === "pro" ? "#2ecc71" : b.plan === "basic" ? "#2ec4b6" : "#5a8a8a",
                  }}>
                    {b.plan || "free"}
                  </span>
                </td>
                <td style={s.td}>
                  <span style={{
                    ...s.planBadge,
                    background: b.sub_status === "active" ? "#0d2e1a" : "#2e0d0d",
                    color: b.sub_status === "active" ? "#2ecc71" : "#e74c3c",
                  }}>
                    {b.sub_status || "trial"}
                  </span>
                </td>
                <td style={{ ...s.td, textAlign: "center" }}>{b.product_count}</td>
                <td style={{ ...s.td, textAlign: "center" }}>{b.sales_count}</td>
                <td style={s.td}>
                  <div style={s.actionBtns}>
                    <button
                      onClick={() => handleUpgrade(b.id, "basic", "active", 30)}
                      disabled={updating === b.id}
                      style={s.upgradeBtn}
                    >
                      Basic
                    </button>
                    <button
                      onClick={() => handleUpgrade(b.id, "pro", "active", 30)}
                      disabled={updating === b.id}
                      style={{ ...s.upgradeBtn, background: "#1a2e1a", color: "#2ecc71", borderColor: "#2ecc71" }}
                    >
                      Pro
                    </button>
                    <button
                      onClick={() => handleUpgrade(b.id, "free", "cancelled", 0)}
                      disabled={updating === b.id}
                      style={{ ...s.upgradeBtn, background: "#2e1a0d", color: "#f5a623", borderColor: "#f5a623" }}
                    >
                      Free
                    </button>
                    <button
                      onClick={() => handleDelete(b.id, b.name)}
                      style={s.deleteBtn}
                    >
                      🗑
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div style={{
  background: "#0f1a1a", border: "1px solid #1e3333",
  borderRadius: "14px", padding: "32px", marginTop: "32px"
}}>
  <h2 style={{ fontSize: "18px", fontWeight: "700", color: "#e8f5f5", marginBottom: "24px" }}>
    📢 Send Announcement to Users
  </h2>

  <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
    <div>
      <label style={{ fontSize: "13px", color: "#5a8a8a", display: "block", marginBottom: "6px" }}>
        Target Audience
      </label>
      <select
        value={announcement.target}
        onChange={(e) => setAnnouncement({ ...announcement, target: e.target.value })}
        style={s.input}
      >
        <option value="all">All Users</option>
        <option value="subscribed">Subscribed Users Only</option>
        <option value="trial">Trial and Expired Users</option>
      </select>
    </div>

    <div>
      <label style={{ fontSize: "13px", color: "#5a8a8a", display: "block", marginBottom: "6px" }}>
        Subject
      </label>
      <input
        type="text"
        value={announcement.subject}
        onChange={(e) => setAnnouncement({ ...announcement, subject: e.target.value })}
        placeholder="e.g. New Feature Alert — Sales Receipt Update"
        style={s.input}
      />
    </div>

    <div>
      <label style={{ fontSize: "13px", color: "#5a8a8a", display: "block", marginBottom: "6px" }}>
        Message
      </label>
      <textarea
        value={announcement.message}
        onChange={(e) => setAnnouncement({ ...announcement, message: e.target.value })}
        placeholder="Write your message here..."
        rows={6}
        style={{ ...s.input, resize: "vertical", lineHeight: "1.6" }}
      />
    </div>

    <button
      onClick={handleAnnouncement}
      disabled={sending}
      style={{
        background: "linear-gradient(135deg, #2ec4b6, #1a9e92)",
        color: "#0a0f0f", border: "none", borderRadius: "10px",
        padding: "14px 32px", fontSize: "15px", fontWeight: "700",
        cursor: sending ? "not-allowed" : "pointer", alignSelf: "flex-start"
      }}
    >
      {sending ? "Sending..." : "Send Announcement"}
    </button>
  </div>
</div>
    </div>
  );
}

const s = {
  loginWrapper: {
    minHeight: "100vh", display: "flex", alignItems: "center",
    justifyContent: "center", background: "#0a0f0f", padding: "20px",
  },
  loginCard: {
    background: "#0f1a1a", border: "1px solid #1e3333",
    borderRadius: "16px", padding: "48px 40px", width: "100%", maxWidth: "420px",
  },
  loginLogo: { display: "flex", alignItems: "center", gap: "12px", marginBottom: "8px" },
  loginTitle: { fontSize: "24px", fontWeight: "700", color: "#2ec4b6" },
  loginSub: { fontSize: "14px", color: "#5a8a8a", marginBottom: "32px" },
  loginForm: { display: "flex", flexDirection: "column", gap: "20px" },
  field: { display: "flex", flexDirection: "column", gap: "8px" },
  label: { fontSize: "13px", color: "#5a8a8a", fontWeight: "500" },
  input: {
    background: "#162424", border: "1px solid #1e3333", borderRadius: "10px",
    padding: "12px 16px", color: "#e8f5f5", fontSize: "15px", outline: "none",
  },
  loginBtn: {
    background: "linear-gradient(135deg, #2ec4b6, #1a9e92)",
    color: "#0a0f0f", border: "none", borderRadius: "10px",
    padding: "14px", fontSize: "15px", fontWeight: "700", cursor: "pointer",
  },
  wrapper: { minHeight: "100vh", background: "#0a0f0f", padding: "32px", color: "#e8f5f5" },
  header: {
    display: "flex", justifyContent: "space-between", alignItems: "center",
    marginBottom: "40px", flexWrap: "wrap", gap: "16px",
  },
  headerLeft: { display: "flex", alignItems: "center", gap: "16px" },
  pageTitle: { fontSize: "28px", fontWeight: "700", color: "#e8f5f5", letterSpacing: "-0.5px" },
  pageSub: { fontSize: "14px", color: "#5a8a8a", marginTop: "4px" },
  logoutBtn: {
    background: "none", border: "1px solid #1e3333", borderRadius: "8px",
    padding: "10px 20px", color: "#5a8a8a", cursor: "pointer", fontSize: "14px",
  },
  statsGrid: {
    display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
    gap: "16px", marginBottom: "40px",
  },
  statCard: {
    background: "#0f1a1a", border: "1px solid #1e3333",
    borderRadius: "14px", padding: "20px", textAlign: "center",
  },
  statIcon: { fontSize: "28px", display: "block", marginBottom: "8px" },
  statValue: { fontSize: "28px", fontWeight: "700", color: "#2ec4b6", marginBottom: "4px" },
  statLabel: { fontSize: "12px", color: "#5a8a8a" },
  sectionTitle: { fontSize: "18px", fontWeight: "600", color: "#e8f5f5", marginBottom: "16px" },
  tableWrap: {
    background: "#0f1a1a", border: "1px solid #1e3333",
    borderRadius: "14px", overflowX: "auto",
  },
  table: { width: "100%", borderCollapse: "collapse", minWidth: "900px" },
  th: {
    textAlign: "left", padding: "14px 16px", fontSize: "12px",
    fontWeight: "600", color: "#5a8a8a", textTransform: "uppercase",
    letterSpacing: "0.5px", borderBottom: "1px solid #1e3333",
    background: "#0f1a1a", whiteSpace: "nowrap",
  },
  tr: { borderBottom: "1px solid #1e3333" },
  td: { padding: "14px 16px", fontSize: "14px", color: "#e8f5f5" },
  planBadge: {
    padding: "4px 10px", borderRadius: "20px",
    fontSize: "12px", fontWeight: "600", textTransform: "capitalize",
  },
  actionBtns: { display: "flex", gap: "6px", flexWrap: "wrap" },
  upgradeBtn: {
    background: "#162424", border: "1px solid #2ec4b6",
    borderRadius: "6px", padding: "4px 10px",
    color: "#2ec4b6", fontSize: "11px", fontWeight: "600", cursor: "pointer",
  },
  deleteBtn: {
    background: "none", border: "1px solid #e74c3c",
    borderRadius: "6px", padding: "4px 8px",
    color: "#e74c3c", fontSize: "14px", cursor: "pointer",
  },
};